import Alpine from "alpinejs";

export default function popup(key, startTs, endTs = null) {

  // normalize to numbers/null once
  startTs = startTs == null ? null : Number(startTs);
  endTs   = endTs   == null ? null : Number(endTs);

  return {
    _open : false,
    seenTs: Alpine.$persist(null).as(`modal_seen:${key}`),
    get popupOpen() {
      return this._open; },
    set popupOpen(v) {
      const wasOpen = this._open;
      this._open = Boolean(v);
      if (wasOpen && !this._open) {
        if (this.seenTs == null || startTs > this.seenTs) {
          this.seenTs = startTs;
        }
      }
    },
    init() {
      if (!Number.isFinite(startTs)) return;
      const now = Math.floor(Date.now() / 1000);
      const inWindow = now >= startTs && (endTs == null || now < endTs);
      if (!inWindow) return;
      const shouldShow = this.seenTs == null || startTs > this.seenTs;
      if (!shouldShow) return;
      this.$nextTick(() => {
        setTimeout(() => {
          this.popupOpen = true;
        }, 7000);
      });
    }
  };
}
